import React, { Dispatch, SetStateAction, forwardRef, useId } from 'react'

import { LockClosed16Filled } from '@fluentui/react-icons'
import { RadioGroup } from '@headlessui/react'
import { FilterStateProps } from '@hooks/useQuestion'

import { tagsStyles } from './styles'

const { radioGroupOption, containerTags } = tagsStyles

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StitchesProps = React.ComponentProps<any>
type OptionsProps = { label: string; value: number | object | string }

interface TagsProps extends StitchesProps {
	options?: Array<OptionsProps>
	disabled?: boolean
	value: Array<OptionsProps> | []
	onChange: Dispatch<SetStateAction<FilterStateProps>>
	name: string
	activeColor?: string
}

export const Tags = forwardRef<HTMLInputElement, TagsProps>(
	(
		{ options, disabled, value, onChange, name, activeColor, ...props },
		ref
	) => {
		const uniqueClass = `custom-tags-${useId().replace(/:/g, '')}`

		return (
			<RadioGroup
				value={value}
				onChange={(item) => {
					onChange((prevState: FilterStateProps) => ({
						...prevState,
						[name]: item,
					}))
				}}
				ref={ref}
				disabled={disabled}
				className={activeColor ? uniqueClass : ''}
				{...props}
			>
				{activeColor && (
					<style>{`
                        .${uniqueClass} [role="radio"][aria-checked="true"] {
                            background-color: transparent !important;
                            border: 1px solid ${activeColor} !important;
                            color: ${activeColor} !important;
                        }
                      
                        .${uniqueClass} [role="radio"][aria-checked="true"]:hover {
                            background-color: transparent !important;
                            border-color: ${activeColor} !important;
                            color: ${activeColor} !important;
                            filter: brightness(0.9);
                        }
                      
                        .${uniqueClass} [role="radio"][aria-checked="true"] * {
                            color: ${activeColor} !important;
                        }
                    `}</style>
				)}

				<div className={containerTags()}>
					{options?.map((item: OptionsProps) => (
						<RadioGroup.Option
							key={item.label}
							value={item.value}
							className={({ active, checked, disabled: disabledItem }) =>
								radioGroupOption({ checked, active, disabledItem })
							}
						>
							{item.label}
							{disabled && <LockClosed16Filled />}
						</RadioGroup.Option>
					))}
				</div>
			</RadioGroup>
		)
	}
)
